import type { oz } from '@weft/utils';
import { NewLineItemProductCommitmentSchema } from './new-line-item-product-commitment-schema';

export const LineItemProductCommitmentSchema = NewLineItemProductCommitmentSchema.openapi('LineItemProductCommitment');

export type LineItemProductCommitment = oz.infer<typeof LineItemProductCommitmentSchema>;